import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment  } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PromotionService {
  mainURL = 'api/promotion/';
  constructor(private http: HttpClient) { }

  usePromotionCode(promotionCode: string) {
    return this.http.post(environment.apiUrl + this.mainURL + 'usepromotion', promotionCode);
  }
}
